module.exports = __webpack_public_path__ + "img/tmf2026_president.d65e90e3.jpg";